import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Meta } from '@angular/platform-browser';
import { TranslatePipe } from '@spartacus/core';

@Component({
  selector: 'app-download-media',
  templateUrl: './download-media.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [MatIcon, TranslatePipe],
})
export class DownloadMediaComponent implements OnInit {
  @Input() items: any;
  backendURL: string = null;
  constructor(private meta: Meta) {}

  ngOnInit() {
    const occURL = this.meta.getTag('name=occ-backend-base-url');
    this.backendURL = occURL.content;
  }
}
